<template>
  <div class="main-cn">
      <div class="main-bd mg20">
          <el-tabs v-model="active_name" @tab-click="handleClick">
              <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value"></el-tab-pane>
          </el-tabs>
          <Finish v-if="active_name == 'order-finish'"></Finish>
          <Clue v-else-if="active_name == 'order-clue'"></Clue>
      </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Finish from "~/views/count/payorder/finish.vue";
import Clue from "~/views/count/payorder/clue.vue";
export default {
  name: "payorder",

  components: {
    Finish,
    Clue
  },

  props: {
      
  },
  
  data() {
      return {
        active_name: 'order-finish',
        active_list: [
          {
            label: '成交订单分析',
            value: 'order-finish',
          },
          {
            label: '订单线索分析',
            value: 'order-clue',
          },
        ],
      };
  },

  mounted() {

  },

  created() {
    //接口权限校验，没有则不展示对应的子菜单
    this.active_list = this.active_list.filter(item=>{
      if(!this.Acs('/order-count/' + item.value)){
        return false;
      }else if(!this.active_name){
        this.active_name = item.value;
      }
      return true;
    })
  },

  methods: {
      handleClick(tab, event) {

      },

      handleFinishClick(tab, event){

      },

      handleGoalClick(tab, event){

      },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/count/payorder.vue